export default async function(userInfo) {
  if (process.client) {
    const ua = navigator.userAgent.toLowerCase()
    const isThunder = /thunder/.test(ua) || /tbc/.test(ua)
    if (isThunder) {
      const getUserid = new Promise((resolve) => {
        xl9.api.getUserId(function(err, userid) {
          if (err) {
            resolve(err)
          }
          resolve(userid)
        })
      })
      const getSessionid = new Promise((resolve) => {
        xl9.api.getSessionId(function(err, sessionid) {
          if (err) {
            resolve(err)
          }
          resolve(sessionid)
        })
      })
      const [userid, sessionid] = await Promise.all([getUserid, getSessionid])
      // setCookie('userid', userid)
      // setCookie('sessionid', sessionid)
      return Object.assign({}, userInfo, {
        userid,
        sessionid
      })
    } else {
      return userInfo
    }
  } else {
    return userInfo
  }
}
